/**
 * @file Sticky Navigation
 */

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/src/ScrollTrigger';

/**
 * Sticky Navigation Component
 */
const vStickyNavigation = () => {
	const stickyNav = document.querySelector( '.v-sticky-navigation' );

	if ( ! stickyNav ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const stickyQuery = window.matchMedia( '(max-width: 1024px)' );
	const trigger     = document.querySelector( wpPostData.is_front_page ? '.v-header__logo-wrap' : '.v-header' );
	// const staticNav   = document.querySelector( '.v-navigation' );

	ScrollTrigger.matchMedia( {
		'(max-width: 1024px)': () => {
			ScrollTrigger.create( {
				trigger,
				start:   'bottom top',
				end:     '+=1',
				onLeave: () => {
					gsap.to( stickyNav, {
						yPercent:  100,
						overwrite: true,
						onStart:   () => {
							stickyNav.classList.add( 'v-sticky-navigation--visible' );
						},
					} );
				},
				onEnterBack: () => {
					gsap.to( stickyNav, {
						yPercent:   0,
						overwrite:  true,
						onComplete: () => {
							stickyNav.classList.remove( 'v-sticky-navigation--visible' );
						},
					} );
				},
			} );
		},
	} );

	stickyQuery.addEventListener( 'change', () => {
		if ( stickyQuery.matches ) {
			return;
		}

		if ( stickyNav.classList.contains( 'v-sticky-navigation--visible' ) ) {
			stickyNav.classList.remove( 'v-sticky-navigation--visible' );
		}
	} );
};

export default vStickyNavigation;
